import { Application } from "@hotwired/stimulus"

const application = Application.start()
const controllerModules = import.meta.glob("./**/*_controller.js", { eager: true })

for (const path in controllerModules) {
  const identifier = path
    .replace(/^\.\//, "")
    .replace(/_controller\.js$/, "")
    .replaceAll("_", "-")
    .replaceAll("/", "--")

  application.register(identifier, controllerModules[path].default)
}

window.Stimulus = application
